export default __webpack_public_path__ + "static/media/mb2.9cfb89ad.jpg";